// extracted by mini-css-extract-plugin
module.exports = {"divider":"mochi-divider_divider__diBsb"};